import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OrganizationService } from 'projects/assist/src/app/organisation/services/organization.service';
import { BaseComponent } from '../../_base/base.component';
import { TranslationTextService } from '../../member/services/translate.service';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent extends BaseComponent {
  constructor(
    override route: ActivatedRoute,
    protected override organizationService: OrganizationService,
    protected override translationTextService: TranslationTextService
  ) {
    super('FOOTER', route, organizationService, translationTextService);
  }
}
